import { render, staticRenderFns } from "./CarouselImage.vue?vue&type=template&id=1c0c950a"
import script from "./CarouselImage.vue?vue&type=script&lang=js"
export * from "./CarouselImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports